/**
 * Detects if the current browser is Safari on iOS/iPadOS.
 * iOS Safari doesn't properly support programmatic downloads,
 * so we need to open files in a new tab instead.
 */
export function detectIOSSafari(): boolean {
  if (typeof navigator === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent;

  // Check for iOS devices
  const isIOS = /iPad|iPhone|iPod/.test(ua);

  // Check for iPadOS (reports as Mac but has touch support)
  const isIPadOS =
    navigator.maxTouchPoints > 1 &&
    ua.includes('Macintosh') &&
    'ontouchend' in document;

  // Check for Safari (exclude Chrome, Firefox, Edge, etc.)
  const isSafari =
    ua.includes('Safari') && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);

  return (isIOS || isIPadOS) && isSafari;
}

// Cache the detection result
let cachedResult: boolean | null = null;

export function isIOSSafari(): boolean {
  cachedResult ??= detectIOSSafari();
  return cachedResult;
}

/** Reset cache — only needed for testing */
export function resetIOSSafariCache(): void {
  cachedResult = null;
}
